import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import useTickets from '../../../../../hooks/ticketsHook/useTickets';
import useAuthUsers from '../../../../../hooks/useAuthUsers';
import { actionSectionIdentifier, sectionIdentifier, statusAction } from '../../../../../constants/ticketsErrors';
import { Box, Card, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useSelector } from '../../../../../redux/store';

function FormTicket({ handleClose, ticketObj = {} }) {
  const [loading, setLoading] = useState(false);
  const { errorResponseCotizacion } = useSelector((state) => state.dagpacket);
  console.log({ errorResponseCotizacion });
  // const { id, provider, rate_provider, detail } = dataError;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();
  const { reportTicket } = useTickets();
  // const{} = useTickets()
  const { enqueueSnackbar } = useSnackbar();
  const { currentUser } = useAuthUsers();

  const onSubmit = async (dataForm) => {
    setLoading(true);
    const errorData = {
      // action: actionSectionIdentifier.comprarGuia,
      // section: sectionIdentifier.cartSection,
      ...ticketObj,
      status: statusAction.pending,
      created_at: new Date(),
      updated_at: new Date(),
      asunto: dataForm.asunto,
      timeStampError: errorResponseCotizacion.timestamp,
      description: dataForm.message,
      user_id: currentUser.id,
      hostUser: currentUser.hostUser
    };
    await reportTicket(errorData);
    setLoading(false);
    enqueueSnackbar('El ticket ha sido abierto exitosamente, pronto le enviaremos respuestas.', { variant: 'success' });
    reset();
    handleClose();
  };
  return (
    <Card sx={{ padding: '15px' }} component="form" onSubmit={handleSubmit(onSubmit)}>
      <Box sx={{ marginBottom: '10px' }}>
        <TextField fullWidth label="Asunto" {...register('asunto', { required: true })} />
        {errors.asunto && (
          <Typography marginTop="5px" fontSize="13px" color="error">
            Este campo es requerido
          </Typography>
        )}
      </Box>
      <Box>
        <TextField fullWidth multiline rows={4} label="Descripcion" {...register('message', { required: true })} />
        {errors.message && (
          <Typography marginTop="5px" fontSize="13px" color="error">
            Este campo es requerido
          </Typography>
        )}
      </Box>
      <LoadingButton type="submit" sx={{ marginTop: '10px' }} loading={loading} fullWidth variant="contained">
        Abrir ticket
      </LoadingButton>
    </Card>
  );
}

export default FormTicket;
